define('lq/events/actions/shareOnFacebook',[
    'lq/events/actions/eventAction'
], function(EventAction) {
    'use strict';

    var fbInitialized = false;

    function ShareOnFacebook(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ShareOnFacebook, EventAction);

    ShareOnFacebook.typeName = 'ShareOnFacebook';

    ShareOnFacebook.prototype.getBatchType = function() {
        return EventAction.DO_NOT_BATCH;
    };

    ShareOnFacebook.prototype.execute = function(continuation) {
        if (fbInitialized) {
            this.showDialog();

            continuation();
        } else {
            var self = this;
            window.fbAsyncInit = function () {
                fbInitialized = true;

                window.FB.init({
                    appId: self.eventData.facebook.appId,
                    xfbml: false,
                    version: 'v2.8'
                });

                self.showDialog();

                continuation();
            }

            var script = document.createElement('script');
            script.src = '//connect.facebook.net/en_US/sdk.js';
            document.head.appendChild(script);
        }
    };

    ShareOnFacebook.prototype.showDialog = function() {
        window.FB.ui({
            method: 'share',
            display: 'popup',
            href: this.piping.parameters.replace(this.eventData.facebook.url)
        }, function (response) { });
    };

    return ShareOnFacebook;
});
